import fetchIntercept from "fetch-intercept";
import { authorizeLoginCookieVerify, unwrap } from "../../api";
import useApp from "../../hooks/useApp";
import { useEffect, useState } from "react";

const Minutes = 15;
const _10_Sec = 10000; // in ms
const Padding = 9000; // in ms
const Timeout = 1000 * 60 * Minutes + Padding;

export default function AutomaticLogout() {
  const { appData } = useApp();
  const user = appData?.auth?.user;

  const [lastActivity, setLastActivity] = useState(new Date());

  async function handleLogout() {
    console.log("logging out because of inactivity");

    localStorage.removeItem("lastSelectedSuperset");
    window.location.href = "/signin";
  }

  function hasTimeExpired(time: Date) {
    const currentTime = new Date();
    const timeSinceLastActivity = currentTime.getTime() - time.getTime();
    return timeSinceLastActivity > Timeout;
  }

  useEffect(() => {
    // Set up interval to check token expiration
    const checkInterval = setInterval(async () => {
      if (hasTimeExpired(lastActivity) && user) {
        console.log("time expired");
        // Token expired, logout user
        try {
          await unwrap(authorizeLoginCookieVerify());
        } catch (e) {
          console.log(e);
          void handleLogout();
        }
      }
    }, _10_Sec);

    return () => {
      clearInterval(checkInterval);
    };
  }, []);

  fetchIntercept.register({
    request(url, config) {
      // Modify the url or config here
      return [url, config];
    },

    requestError(error) {
      // Called when an error occurred during another 'request' interceptor call
      return Promise.reject(error);
    },

    response(response) {
      if (!response.url.includes("authorize/login") && !response.url.includes("authorize/link")) {
        setLastActivity(new Date());
        if (response.status === 401) {
          void handleLogout();
          return response;
        }
      }

      // Modify the response object
      return response;
    },

    responseError(error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });

  return null;
}
